/**
 * Copyright (c) Qwoach LLC 2020. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Created by Artem Bogush <artem@qwoach.com> on 7/18/20
 *
 */
import {Type} from "class-transformer"
import BaseObject from "@shared/BaseObject";
import DriveStorageAddon from "@shared/Subscription/Addons/DriveStorageAddon";

export default class SubscriptionAddons extends BaseObject {

	@Type(() => DriveStorageAddon)
	driveStorageAddons: DriveStorageAddon[] = []

	teamExtraSeats: number = 0
	teamExtraSeatsRecentChange = {} //{date: change} i.e {02-02-2020: +2 05-02-2022: -1} Changes are reset for each billing cycle

}
